// import reducers
import auth from './auth';

// const rootReducer = 

export default {
    auth
};